// extracted by mini-css-extract-plugin
export default {"list":"tsdNFk","listItem":"ui22WL","row":"Zgw2Rx"};